import { TourConfig, startTour, CONTINUE_PLATFORM_TOUR_BUTTON } from './TourSystem';
import PageWelcomeModal from './PageWelcomeModal';
import 'driver.js/dist/driver.css';

const workspaceTourConfig: TourConfig = {
    tourId: 'workspace',
    steps: [
        {
            element: '#workspace-rooms',
            popover: {
                title: '🏢 Room Directory',
                description: 'This sidebar lists all your collaborative spaces. Create separate rooms for different projects, teams, or client meetings.',
                side: "right",
            }
        },
        {
            element: '#workspace-create',
            popover: {
                title: '➕ Create Room',
                description: 'Need a new space? Click here to instantly generate a new private or public room.',
                side: "bottom",
            }
        },
        {
            element: '#workspace-tools',
            popover: {
                title: '🛠️ Toolkit',
                description: 'Switch between different collaboration modes instantly.',
                side: "bottom",
            }
        },
        {
            element: '#workspace-tool-video',
            popover: {
                title: '🎥 Video Conference',
                description: 'Start high-quality video calls with your team. Includes screen sharing and recording capabilities.',
                side: "bottom",
            }
        },
        {
            element: '#workspace-tool-voice',
            popover: {
                title: '🎤 Voice Channel',
                description: 'Drop into a low-latency voice channel for quick syncs and casual conversations.',
                side: "bottom",
            }
        },
        {
            element: '#workspace-tool-chat',
            popover: {
                title: '💬 Team Chat',
                description: 'Persistent text chat for sharing links, updates, and messages that need to be saved.',
                side: "bottom",
            }
        },
        {
            element: '#workspace-tool-whiteboard',
            popover: {
                title: '✏️ Interactive Whiteboard',
                description: 'Brainstorm together! Draw diagrams, sticky notes, and flows in real-time on an infinite canvas.',
                side: "bottom",
            }
        },
        {
            element: '#workspace-tool-documents',
            popover: {
                title: '📝 Live Docs',
                description: 'Co-edit documents in real-time. Write specs, meeting notes, and agreements together.',
                side: "bottom",
            }
        },
        {
            element: '#workspace-tool-files',
            popover: {
                title: '📁 File Storage',
                description: 'Upload and share large files securely within the room. Access them anytime.',
                side: "bottom",
            }
        },
        {
            popover: {
                title: '🌐 Ready to Collaborate',
                description: `Jump into a room and start working together with your team from anywhere in the world.${CONTINUE_PLATFORM_TOUR_BUTTON}`,
            }
        }
    ],
};

export const startWorkspaceTour = () => {
    startTour(workspaceTourConfig);
};

const WorkspaceTour = () => {
    return (
        <PageWelcomeModal
            title="Welcome to Workspace"
            description="Your all-in-one virtual office for global collaboration."
            onStartTour={startWorkspaceTour}
            tourId="workspace"
        />
    );
};

export default WorkspaceTour;
